import { ColDef } from "ag-grid-community";
import { CustomCellRendererProps } from "ag-grid-react";
import { NormalizedCostWidgetTableDataType } from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/utils/types/types";
import {
  normalizedCostWidgetTableActualCostValueGetter,
  normalizedCostWidgetTableMonthValueGetter,
  normalizedCostWidgetTableNormalizedCostValueGetter,
} from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/utils/helpers/valueGetters";
import {
  normalizedCostWidgetTableActualCostComparator,
  normalizedCostWidgetTableMonthComparator,
  normalizedCostWidgetTableNormalizedCostComparator,
} from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/utils/helpers/comparators";
import { NormalizedCostWidgetTableCostCell } from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/components/table/NormalizedCostWidgetTableCostCell";
import { WidgetNormalizedCostVisualization } from "@/services/cloudchipr.api";

export const getNormalizedCostWidgetTableColDef = (
  visualization?: WidgetNormalizedCostVisualization,
): ColDef<NormalizedCostWidgetTableDataType>[] => {
  const colDefs: ColDef<NormalizedCostWidgetTableDataType>[] = [
    {
      field: "date",
      headerName: "Month",
      valueGetter: normalizedCostWidgetTableMonthValueGetter,
      comparator: normalizedCostWidgetTableMonthComparator,
    },
  ];

  if (visualization?.actual_total_cost) {
    colDefs.push({
      field: "regular.cost",
      headerName: "Actual Cost",
      valueGetter: normalizedCostWidgetTableActualCostValueGetter,
      comparator: normalizedCostWidgetTableActualCostComparator,
      cellRenderer: ({
        data,
      }: CustomCellRendererProps<NormalizedCostWidgetTableDataType>) => {
        return (
          <NormalizedCostWidgetTableCostCell
            cost={data?.regular?.cost ?? 0}
            trend={data?.regular?.trend}
          />
        );
      },
    });
  }

  if (visualization?.normalized_total_cost) {
    colDefs.push({
      field: "normalized.cost",
      headerName: "Normalized Cost",
      valueGetter: normalizedCostWidgetTableNormalizedCostValueGetter,
      comparator: normalizedCostWidgetTableNormalizedCostComparator,
      cellRenderer: ({
        data,
      }: CustomCellRendererProps<NormalizedCostWidgetTableDataType>) => {
        return (
          <NormalizedCostWidgetTableCostCell
            cost={data?.normalized?.cost ?? 0}
            trend={data?.normalized?.trend}
          />
        );
      },
    });
  }

  return colDefs;
};
